import EventBus from 'eventing-bus';
import Switch from '@material-ui/core/Switch';
import TextField from '@mui/material/TextField';
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { ValidatorForm, TextValidator } from 'react-material-ui-form-validator';

import './profile.css';
import { updateProfile, setShowPhoneModal } from '../../../store/Settings/index.js';
import { setSocialPassword, toggle2FA, logout, revokeAllSessions, revokeWorkspaceSessions, sendSMS2FA, enableSMS2FA } from '../../../store/Auth/index.js';

const Profile = () => {
    const dispatch = useDispatch();
    const { userDetails, currentWorkspace } = useSelector(state => state['Settings']);

    const [userData, setUserData] = useState({});
    const [isFetching, setIsFetching] = useState(false);
    const [is2FAFetching, setIs2FAFetching] = useState(false);
    const [twoFaDialog, setTwoFaDialog] = useState({ open: false, password: '', enabling: false });
    const [isSmsFetching, setIsSmsFetching] = useState(false);
    const [isRevoking, setIsRevoking] = useState(false);
    const [isRevokingWorkspace, setIsRevokingWorkspace] = useState(false);
    const [logoutDialog, setLogoutDialog] = useState({ open: false, type: '' }); // 'personal' or 'workspace'

    const [showState, setShowState] = useState({ hasPassword: false, isSocialUser: false });
    const [passwordForm, setPasswordFrom] = useState({});

    useEffect(() => {
        setUserData(userDetails);
        setShowState({ hasPassword: userDetails && userDetails['hashedPassword'], isSocialUser: userDetails && userDetails['provider'] && userDetails['provider'] !== 'local' });
    }, [userDetails])

    // Handle social login password setting
    const handleSocialPasswordSubmit = e => {
        e.preventDefault();
        if (passwordForm['newPassword'] !== passwordForm['confirmPassword']) return EventBus.publish('error', 'New Password must match Confirm Password');

        setIsFetching(true);
        dispatch(setSocialPassword({
            formData: passwordForm,
            successCallback: () => {
                setIsFetching(false);
                setPasswordFrom({ currentPassword: '', newPassword: '', confirmPassword: '' });
                setShowState(prev => ({ ...prev, currentPassword: false, newPassword: false, confirmPassword: false }));
            },
            failCallback: () => setIsFetching(false)
        }));
    }
    const togglePasswordVisibility = field => setShowState(prev => ({ ...prev, [field]: !prev[field] }))
    const handleSocialPasswordChange = e => setPasswordFrom({ ...passwordForm, [e['target']['name']]: e['target']['value'] })

    const handleChange = e => setUserData({ ...userData, [e['target']['name']]: e['target']['value'] })

    // Handle 2FA toggle
    const handleToggle2FA = (event) => {
        const enabling = event.target.checked;
        // Only show password dialog when disabling for users with local auth
        if (!enabling && (userDetails?.['provider'] === 'local' || userDetails?.['hashedPassword'])) setTwoFaDialog({ open: true, password: '', enabling });
        else confirmToggle2FA(enabling, '');
    };

    const handleToggleSMS2FA = () => {
        if (!userData?.['phone']) return dispatch(setShowPhoneModal(true));
        const enabling = !userData?.['smsEnabled'];
        setIsSmsFetching(true);
        if (!enabling) {
            dispatch(enableSMS2FA({
                enable: false,
                successCallback: () => { setIsSmsFetching(false); setUserData(prev => ({ ...prev, smsEnabled: false })); },
                failCallback: () => setIsSmsFetching(false),
            }));
            return;
        }
        dispatch(sendSMS2FA({
            successCallback: () => {
                dispatch(enableSMS2FA({
                    enable: true,
                    successCallback: () => { setIsSmsFetching(false); setUserData(prev => ({ ...prev, smsEnabled: true })); },
                    failCallback: () => setIsSmsFetching(false),
                }));
            },
            failCallback: (errMsg) => {
                setIsSmsFetching(false);
                if (errMsg && errMsg.toLowerCase().includes('phone')) {
                    setUserData(prev => ({ ...prev, phone: null }));
                    dispatch(setShowPhoneModal(true));
                }
            },
        }));
    };

    const confirmToggle2FA = (enable, password) => {
        setIs2FAFetching(true);
        dispatch(toggle2FA({
            enable,
            password,
            successCallback: (data) => {
                setIs2FAFetching(false);
                setTwoFaDialog({ open: false, password: '', enabling: false });
                setUserData({ ...userData, twoFaEnabled: data.twoFaEnabled });
            },
            failCallback: () => {
                setIs2FAFetching(false);
                setTwoFaDialog({ open: false, password: '', enabling: false });
            }
        }));
    };

    const handleDialogClose = () => {
        setTwoFaDialog({ open: false, password: '', enabling: false });
    };

    const handleDialogConfirm = () => {
        if (!twoFaDialog.enabling && !twoFaDialog.password && (userDetails?.['provider'] === 'local' || userDetails?.['hashedPassword'])) {
            EventBus.publish('error', 'Please enter your password');
            return;
        }
        confirmToggle2FA(twoFaDialog.enabling, twoFaDialog.password);
    };

    // Handle logout from all devices
    const handleLogoutDevices = () => {
        setLogoutDialog({ open: true, type: 'personal' });
    };

    // Handle logout all workspace devices
    const handleLogoutWorkspaceDevices = () => {
        setLogoutDialog({ open: true, type: 'workspace' });
    };

    // Close logout dialog
    const handleLogoutDialogClose = () => {
        setLogoutDialog({ open: false, type: '' });
    };

    // Confirm logout action
    const handleLogoutConfirm = () => {
        if (logoutDialog.type === 'personal') {
            setIsRevoking(true);
            setLogoutDialog({ open: false, type: '' });
            dispatch(revokeAllSessions({
                successCallback: () => {
                    EventBus.publish('success', 'Successfully logged out from all devices');
                    setTimeout(() => {
                        dispatch(logout());
                    }, 1000);
                },
                failCallback: () => {
                    setIsRevoking(false);
                    EventBus.publish('error', 'Failed to logout from all devices');
                }
            }));
        } else if (logoutDialog.type === 'workspace') {
            setIsRevokingWorkspace(true);
            setLogoutDialog({ open: false, type: '' });
            dispatch(revokeWorkspaceSessions({
                workspaceId: currentWorkspace._id,
                successCallback: () => {
                    EventBus.publish('success', 'Successfully logged out all workspace users from all devices');
                    setTimeout(() => {
                        dispatch(logout());
                    }, 1000);
                },
                failCallback: () => {
                    setIsRevokingWorkspace(false);
                    EventBus.publish('error', 'Failed to logout workspace users');
                }
            }));
        }
    };

    return (

        <div className='tabs-content' >
            <div className='title-top-block' >
                <div className='left-area' >
                    <h2>Profile </h2>
                </div>
            </div>
            < div className='setting-profile-area' >
                <div className='setting-profile-box' >
                    <ValidatorForm className='validator-form' >
                        <div className='title-area' >
                            <i className='icon fa fa-user' > </i>
                            < h4 > Name </h4>
                        </div>
                        < div className='row' >
                            <div className='col-lg-6 col-md-12' >
                                <div className='group-form' >
                                    <label>First </label>
                                    < TextValidator
                                        required
                                        fullWidth
                                        type='text'
                                        margin='dense'
                                        name='firstName'
                                        variant='outlined'
                                        onChange={handleChange}
                                        validators={['required']}
                                        value={userData?.['firstName']}
                                        className='login-input-fields'
                                        placeholder='Enter your First Name'
                                        errorMessages={['First Name can not be empty']}
                                        onBlur={() => dispatch(updateProfile(userData))}
                                    />
                                </div>
                            </div>
                            < div className='col-lg-6 col-md-12' >
                                <div className='group-form' >
                                    <label>Last </label>
                                    < TextValidator
                                        required
                                        fullWidth
                                        type='text'
                                        margin='dense'
                                        name='lastName'
                                        variant='outlined'
                                        onChange={handleChange}
                                        validators={['required']}
                                        value={userData?.['lastName']}
                                        className='login-input-fields'
                                        placeholder='Enter your Last Name'
                                        errorMessages={['Last Name can not be empty']}
                                        onBlur={() => dispatch(updateProfile(userData))}
                                    />
                                </div>
                            </div>
                        </div>

                        < div className='title-area' >
                            <i className='icon fa fa-envelope' > </i>
                            < h4 > Email </h4>
                        </div>
                        < div className='row' >
                            <div className='col-12' >
                                <div className='group-form' >
                                    <TextValidator
                                        disabled
                                        fullWidth
                                        type='email'
                                        name='email'
                                        margin='dense'
                                        variant='outlined'
                                        value={userData?.['email']}
                                        className='login-input-fields'
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Regular password section */}
                        {
                            !showState['isSocialUser'] && (
                                <>
                                    <div className='title-area style-two' >
                                        <div className='title-inner' >
                                            <i className='icon fa fa-lock' > </i>
                                            < h4 > Update Password </h4>
                                        </div>
                                    </div>

                                    < ValidatorForm className='validator-form' >
                                        {/* Current Password */}
                                        <div className='row' >
                                            <div className='col-12' >
                                                <div className='group-form' >
                                                    <label>Current Password </label>
                                                    < div className='password-field-wrapper' >
                                                        <TextValidator
                                                            required
                                                            fullWidth
                                                            margin='dense'
                                                            variant='outlined'
                                                            name='currentPassword'
                                                            validators={['required']}
                                                            className='login-input-fields'
                                                            onChange={handleSocialPasswordChange}
                                                            placeholder='Enter your current password'
                                                            value={passwordForm['currentPassword']}
                                                            errorMessages={['Current password is required']}
                                                            type={showState['currentPassword'] ? 'text' : 'password'}
                                                        />
                                                        <button type='button' className='toggle-password-visibility' onClick={() => togglePasswordVisibility('currentPassword')}>
                                                            <i className={`fa ${showState['currentPassword'] ? 'fa-eye-slash' : 'fa-eye'}`}> </i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* New Password */}
                                        <div className='row' >
                                            <div className='col-12' >
                                                <div className='group-form' >
                                                    <label>New Password </label>
                                                    < div className='password-field-wrapper' >
                                                        <TextValidator
                                                            required
                                                            fullWidth
                                                            margin='dense'
                                                            variant='outlined'
                                                            name='newPassword'
                                                            validators={['required']}
                                                            className='login-input-fields'
                                                            placeholder='Enter new password'
                                                            onChange={handleSocialPasswordChange}
                                                            value={passwordForm.newPassword}
                                                            errorMessages={['New password is required']}
                                                            type={showState['newPassword'] ? 'text' : 'password'}
                                                        />
                                                        <button type='button' className='toggle-password-visibility' onClick={() => togglePasswordVisibility('newPassword')}>
                                                            <i className={`fa ${showState['newPassword'] ? 'fa-eye-slash' : 'fa-eye'}`}> </i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Confirm Password */}
                                        <div className='row' >
                                            <div className='col-12' >
                                                <div className='group-form' >
                                                    <label>Confirm Password </label>
                                                    < div className='password-field-wrapper' >
                                                        <TextValidator
                                                            required
                                                            fullWidth
                                                            margin='dense'
                                                            variant='outlined'
                                                            name='confirmPassword'
                                                            validators={['required']}
                                                            className='login-input-fields'
                                                            placeholder='Confirm new password'
                                                            onChange={handleSocialPasswordChange}
                                                            value={passwordForm['confirmPassword']}
                                                            errorMessages={['Confirm password is required']}
                                                            type={showState['confirmPassword'] ? 'text' : 'password'}
                                                        />
                                                        <button type='button' className='toggle-password-visibility' onClick={() => togglePasswordVisibility('confirmPassword')}>
                                                            <i className={`fa ${showState['confirmPassword'] ? 'fa-eye-slash' : 'fa-eye'}`}> </i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        < div className='row mb-3' >
                                            <div className='col-12' >
                                                <button className='btn-style-new' disabled={isFetching} onClick={handleSocialPasswordSubmit} >
                                                    {isFetching ? 'Processing...' : 'Update Password'}
                                                </button>
                                            </div>
                                        </div>
                                    </ValidatorForm>
                                </>
                            )
                        }


                        {/* Social login password section */}
                        {
                            showState['isSocialUser'] && (
                                <>
                                    <div className='title-area style-two' >
                                        <div className='title-inner' >
                                            <i className='icon fa fa-lock' > </i>
                                            < h4 > {showState['hasPassword'] ? 'Update Password' : 'Set Password'} </h4>
                                        </div>
                                        < div className='social-login-info' >
                                            <span>You signed up with {userDetails?.['provider']} </span>
                                        </div>
                                    </div>

                                    < ValidatorForm className='validator-form' >
                                        {/* Current password field - only shown if user already has a password */}
                                        {
                                            showState['hasPassword'] && (
                                                <div className='row' >
                                                    <div className='col-12' >
                                                        <div className='group-form' >
                                                            <label>Current Password </label>
                                                            < div className='password-field-wrapper' >
                                                                <TextValidator
                                                                    fullWidth
                                                                    margin='dense'
                                                                    variant='outlined'
                                                                    name='currentPassword'
                                                                    className='login-input-fields'
                                                                    onChange={handleSocialPasswordChange}
                                                                    placeholder='Enter your current password'
                                                                    value={passwordForm['currentPassword']}
                                                                    type={showState['currentPassword'] ? 'text' : 'password'}
                                                                />
                                                                <button type='button' className='toggle-password-visibility' onClick={() => togglePasswordVisibility('currentPassword')
                                                                }>
                                                                    <i className={`fa ${showState['currentPassword'] ? 'fa-eye-slash' : 'fa-eye'}`}> </i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }

                                        {/* New password field */}
                                        <div className='row' >
                                            <div className='col-12' >
                                                <div className='group-form' >
                                                    <label>New Password </label>
                                                    < div className='password-field-wrapper' >
                                                        <TextValidator
                                                            required
                                                            fullWidth
                                                            margin='dense'
                                                            variant='outlined'
                                                            name='newPassword'
                                                            validators={['required']}
                                                            className='login-input-fields'
                                                            placeholder='Enter new password'
                                                            onChange={handleSocialPasswordChange}
                                                            value={passwordForm.newPassword}
                                                            errorMessages={['New password is required']}
                                                            type={showState['newPassword'] ? 'text' : 'password'}
                                                        />
                                                        <button type='button' className='toggle-password-visibility' onClick={() => togglePasswordVisibility('newPassword')}>
                                                            <i className={`fa ${showState['newPassword'] ? 'fa-eye-slash' : 'fa-eye'}`}> </i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Confirm password field */}
                                        <div className='row' >
                                            <div className='col-12' >
                                                <div className='group-form' >
                                                    <label>Confirm Password </label>
                                                    < div className='password-field-wrapper' >
                                                        <TextValidator
                                                            required
                                                            fullWidth
                                                            margin='dense'
                                                            variant='outlined'
                                                            name='confirmPassword'
                                                            validators={['required']}
                                                            className='login-input-fields'
                                                            placeholder='Confirm new password'
                                                            onChange={handleSocialPasswordChange}
                                                            value={passwordForm['confirmPassword']}
                                                            errorMessages={['Confirm password is required']}
                                                            type={showState['confirmPassword'] ? 'text' : 'password'}
                                                        />
                                                        <button type='button' className='toggle-password-visibility' onClick={() => togglePasswordVisibility('confirmPassword')}>
                                                            <i className={`fa ${showState['confirmPassword'] ? 'fa-eye-slash' : 'fa-eye'}`}> </i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        < div className='row mb-3' >
                                            <div className='col-12' >
                                                <button className='btn-style-new' disabled={isFetching} onClick={handleSocialPasswordSubmit} >
                                                    {isFetching ? 'Processing...' : (showState['hasPassword'] ? 'Update Password' : 'Set Password')}
                                                </button>
                                            </div>
                                        </div>
                                    </ValidatorForm>
                                </>
                            )}

                        <div className='title-area' >
                            <i className='icon fa fa-shield' > </i>
                            < h4 > Security </h4>
                        </div>
                        < div className='row' >
                            <div className='col-12' >
                                <div className='switch-group' >
                                    <label>
                                        Enable Two Factor Authentication on login (Email)
                                        < i className='icon fa fa-info' title='Adds an extra layer of security by requiring a verification code sent to your email' > </i>
                                    </label>
                                    < Switch
                                        checked={userData?.['twoFaEnabled'] || false}
                                        onChange={handleToggle2FA}
                                        disabled={is2FAFetching}
                                    />
                                </div>
                                <div className='switch-group' style={{ marginTop: '12px' }}>
                                    <label style={{ opacity: userData?.['phone'] ? 1 : 0.5 }}>
                                        Enable Two Factor Authentication on login (SMS)
                                        <i className='icon fa fa-info' title='Requires a phone number. A code will be sent via SMS on login.'></i>
                                        {!userData?.['phone'] && <span style={{ fontSize: '12px', color: '#94a3b8', marginLeft: '8px' }}>— Add a phone number to enable</span>}
                                    </label>
                                    <Switch
                                        checked={userData?.['smsEnabled'] || false}
                                        onChange={handleToggleSMS2FA}
                                        disabled={isSmsFetching || !userData?.['phone']}
                                        color='primary'
                                    />
                                </div>
                                < div className='logout-btns-group' >
                                    <button
                                        className='logout-btn'
                                        onClick={handleLogoutDevices}
                                        disabled={isRevoking}
                                    >
                                        <i className='icon fa fa-sign-out' > </i>
                                        {isRevoking ? 'Logging out...' : 'Log out of all devices'}
                                    </button>
                                    < button
                                        className='logout-btn'
                                        onClick={handleLogoutWorkspaceDevices}
                                        disabled={isRevokingWorkspace}
                                    >
                                        <i className='icon fa fa-sign-out' > </i>
                                        {isRevokingWorkspace ? 'Logging out...' : 'Log out all users from all devices of organization'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </ValidatorForm>
                </div>
            </div>

            {/* 2FA Password Confirmation Dialog */}
            <Modal isOpen={twoFaDialog.open} className={`main-modal new-user-modal modal-dialog-centered password-modal`}>
                <ModalHeader toggle={handleDialogClose}>
                    <h3>{twoFaDialog.enabling ? 'Enable' : 'Disable'} Two - Factor Authentication </h3>
                </ModalHeader>
                < ModalBody >
                    <div className='credits-area workspace-modal mt-4' >
                        <div className='group-form' >
                            <p>
                                {
                                    twoFaDialog.enabling
                                        ? 'You are about to enable 2FA. You will receive a verification code via email each time you log in.'
                                        : 'You are about to disable 2FA. Your account will be less secure.'
                                }
                            </p>
                            {
                                !twoFaDialog.enabling && (userDetails?.['provider'] === 'local' || userDetails?.['hashedPassword']) && (
                                    <p>
                                        Please enter your password to confirm:
                                    </p>
                                )
                            }
                        </div>
                        < div className='group-form' >
                            <label>Enter your password </label>
                            {
                                !twoFaDialog.enabling && (userDetails?.['provider'] === 'local' || userDetails?.['hashedPassword']) && (
                                    <div className='password-field-wrapper'>
                                        <TextField
                                            fullWidth
                                            hiddenLabel
                                            size="small"
                                            type={showState['twoFaPassword'] ? 'text' : 'password'}
                                            placeholder='Enter your password'
                                            variant="standard"
                                            name='password'
                                            value={twoFaDialog.password}
                                            onChange={(e) => setTwoFaDialog({ ...twoFaDialog, password: e.target.value })}
                                        />
                                        <button type='button' className='toggle-password-visibility' onClick={() => togglePasswordVisibility('twoFaPassword')}>
                                            <i className={`fa ${showState['twoFaPassword'] ? 'fa-eye-slash' : 'fa-eye'}`}> </i>
                                        </button>
                                    </div>
                                )}
                        </div>
                        < div className='footer-modal-area' >
                            <button className='btn-style-border' onClick={handleDialogClose} > Cancel </button>
                            < button className='btn-style-new' onClick={handleDialogConfirm} disabled={is2FAFetching} >
                                {is2FAFetching ? 'Processing...' : 'Confirm'}
                            </button>
                        </div>
                    </div>
                </ModalBody>
            </Modal>

            {/* Logout Confirmation Dialog */}
            <Modal isOpen={logoutDialog.open} className={`main-modal new-user-modal modal-dialog-centered password-modal`}>
                <ModalHeader toggle={handleLogoutDialogClose}>
                    <h3>
                        {logoutDialog.type === 'personal' ? 'Logout From All Devices' : 'Logout All Users'}
                    </h3>
                </ModalHeader>
                <ModalBody>
                    <div className='credits-area workspace-modal mt-4'>
                        <div className='group-form'>
                            {logoutDialog.type === 'personal' ? (
                                <>
                                    <p><strong>Are you sure you want to logout from all devices?</strong></p>
                                    <p>This will:</p>
                                    <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
                                        <li>Log you out from all browsers and devices</li>
                                        <li>You will need to login again on this device</li>
                                        <li>All your active sessions will be terminated</li>
                                    </ul>
                                </>
                            ) : (
                                <>
                                    <p style={{ color: '#ff6b6b', fontWeight: 'bold' }}>
                                        ⚠️ WARNING: Critical Action
                                    </p>
                                    <p><strong>This will logout ALL users in your organization from all their devices!</strong></p>
                                    <p>Effects:</p>
                                    <ul style={{ paddingLeft: '20px', marginTop: '10px' }}>
                                        <li>All team members will be logged out immediately</li>
                                        <li>Everyone will need to login again</li>
                                        <li>All active work sessions will be terminated</li>
                                        <li>This action cannot be undone</li>
                                    </ul>
                                    <p style={{ marginTop: '15px', fontStyle: 'italic' }}>
                                        Use this only in case of security concerns.
                                    </p>
                                </>
                            )}
                        </div>
                        <div className='footer-modal-area'>
                            <button className='btn-style-border' onClick={handleLogoutDialogClose}>
                                Cancel
                            </button>
                            <button
                                className='btn-style-new'
                                onClick={handleLogoutConfirm}
                                disabled={isRevoking || isRevokingWorkspace}
                                style={logoutDialog.type === 'workspace' ? { backgroundColor: '#ff6b6b' } : {}}
                            >
                                {(isRevoking || isRevokingWorkspace) ? 'Processing...' : 'Confirm Logout'}
                            </button>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </div>
    );
};

export default Profile;